import React, { useEffect, useState, useContext, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { ContextBoard } from "../../context/ContextBoard";
import { toast, ToastContainer } from "react-toastify";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FaRegFilePdf } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function StudentGenderChangeXI() {
  const navigate = useNavigate();

  const { state } = useLocation();
  const candidateData = state?.studentData || null;

  const photographRef = useRef();
  const signatureRef = useRef();
  const casteRef = useRef();
  const divyangRef = useRef();

  const [photoFile, setPhotoFile] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [casteFile, setCasteFile] = useState(null);
  const [divyangFile, setDivyangFile] = useState(null);

  const [photoBase64, setPhotoBase64] = useState("");
  const [photoName, setPhotoName] = useState("");
  const [photourl, setPhotourl] = useState("");

  const [signBase64, setSignBase64] = useState("");
  const [signName, setSignName] = useState("");
  const [signurl, setSignurl] = useState("");

  const [casteBase64, setCasteBase64] = useState("");
  const [casteName, setCasteName] = useState("");
  const [casteurl, setCasteurl] = useState("");

  const [divyangBase64, setDivyangBase64] = useState("");
  const [divyangName, setDivyangName] = useState("");
  const [divyangurl, setDivyangurl] = useState("");

  const [showCropper, setShowCropper] = useState(false);
  const [cropperImage, setCropperImage] = useState("");
  const cropperRef = useRef(null);

  const [additionalfiltersubj, setAdditionalfiltersubj] = useState([]);

  const [olddivyangFile, setOlddivyangFile] = useState(null);

  const [optional1, setOptional1] = useState("");
  const [optional2, setOptional2] = useState("");
  const [artselective, setArtselective] = useState("");

  const [before2010, setBefore2010] = useState("");

  const [selectedSubjectNames, setSelectedSubjectNames] = useState({
    coresubject: "",
    matribhasa: "",
    // compulsory_one: "",
    // compulsory_two: "",
    additionalsubject: "",
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
    optional1: "",
    optional2: "",
    artselective: "",
  });

  const [selectedArtsSubjects, setSelectedArtsSubjects] = useState({
    arts_optional_one: "",
    arts_optional_two: "",
    arts_optional_three: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteList, setCasteList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [compulsory, setCompulsory] = useState([]);
  const [optionalsubj, setOptionalsubj] = useState([]);
  const [additionalsubj, setAdditionalsubj] = useState([]);
  const [optionalfiltersubj, setOptionalfiltersubj] = useState([]);
  const [compulsoryonename, setCompulsoryonename] = useState("");
  const [compulsorytwoname, setCompulsorytwoname] = useState("");
  const [artsSubjects, setArtsSubjects] = useState([]);
  const [coresubject, setCoresubject] = useState([]);
  const [matribhasa, setMatribhasa] = useState([]);
  const [electivefiltersubj, setElectivefiltersubj] = useState([]);

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [exregularornot, setExRegularOrNot] = useState(false);

  const [formData, setFormData] = useState({
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    apaar_id: "",
    section_val: "",
    roll_no: "",
    clasS_ROLL_NO: "",
    stream: "",
    coresubject: "",
    matribhasa: "",
    compulsory_one: "",
    compulsory_two: "",
    additionalsubject: "",
    medium_of_exam: "",
    // pen_no: "",
  });
  const handleArtsOptionalChange = (e) => {
    const { name, value } = e.target;

    setSelectedArtsSubjects((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    // ✅ Hindi restrictions
    if (
      formData.coresubject === "HNA" &&
      (formData.additionalsubject === "HIN" || artselective === "HIN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "HIN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }
    if (formData.coresubject === "HNA" && artselective === "HIN") {
      setArtselective("");
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
    }
    // ✅ English restrictions
    if (
      formData.coresubject === "ENA" &&
      (formData.additionalsubject === "ENG" ||
        formData.additionalsubject === "FEN" ||
        artselective === "ENG" ||
        artselective === "FEN")
    ) {
      setFormData((prev) => ({
        ...prev,
        additionalsubject: "",
      }));
      if (artselective === "ENG" || artselective === "FEN") {
        setArtselective("");
        setSelectedSubjectNames((prev) => ({ ...prev, artselective: "" }));
      }
    }

    // ✅ Science stream restrictions
    if (formData.stream === "SCIENCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Commerce stream restrictions
    if (formData.stream === "COMMERCE") {
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({
          ...prev,
          additionalsubject: "",
        }));
      }
    }

    // ✅ Arts stream restrictions
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "MAT" ||
        arts_optional_two === "MAT" ||
        arts_optional_three === "MAT"
      ) {
        if (
          formData.additionalsubject === "MAT" ||
          formData.additionalsubject === "STA"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }

      // If STA selected anywhere, clear additionalsubject if it's MAT/STA
      if (
        arts_optional_one === "STA" ||
        arts_optional_two === "STA" ||
        arts_optional_three === "STA"
      ) {
        if (
          formData.additionalsubject === "STA" ||
          formData.additionalsubject === "MAT"
        ) {
          setFormData((prev) => ({
            ...prev,
            additionalsubject: "",
          }));
        }
      }
    }
  }, [
    formData.coresubject,
    formData.stream,
    formData.additionalsubject,
    optional1,
    optional2,
    selectedArtsSubjects,
  ]);

  useEffect(() => {
    if (formData.stream === "ARTS") {
      const { arts_optional_one, arts_optional_two, arts_optional_three } =
        selectedArtsSubjects;

      // If MAT is selected anywhere → reset STA from additional subject
      if (
        (arts_optional_one === "MAT" ||
          arts_optional_two === "MAT" ||
          arts_optional_three === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA is selected anywhere → reset MAT from additional subject
      if (
        (arts_optional_one === "STA" ||
          arts_optional_two === "STA" ||
          arts_optional_three === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [
    formData.stream,
    formData.additionalsubject,
    selectedArtsSubjects.arts_optional_one,
    selectedArtsSubjects.arts_optional_two,
    selectedArtsSubjects.arts_optional_three,
  ]);

  useEffect(() => {
    // 🔹 Science stream MAT–STA restrictions
    if (formData.stream === "SCIENCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be STA
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "STA"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If STA chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "STA" || optional2 === "STA") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }

    // 🔹 Commerce stream MAT–CAE restrictions
    if (formData.stream === "COMMERCE") {
      // If MAT chosen in optional1/optional2 → additional subject cannot be CAE
      if (
        (optional1 === "MAT" || optional2 === "MAT") &&
        formData.additionalsubject === "CAE"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }

      // If CAE chosen in optional1/optional2 → additional subject cannot be MAT
      if (
        (optional1 === "CAE" || optional2 === "CAE") &&
        formData.additionalsubject === "MAT"
      ) {
        setFormData((prev) => ({ ...prev, additionalsubject: "" }));
        return;
      }
    }
  }, [formData.stream, formData.additionalsubject, optional1, optional2]);

  useEffect(() => {
    setLoading(true);

    if (!candidateData) {
      navigate("/intermediate-admin-dashboard");
      return;
    }

    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const coreSubjects = getSessionData("coreSubjects") || [];
    const matri_BhasaSubjects = getSessionData("matri_BhasaSubjects") || [];
    const compulsory_Paper_2Subjects =
      getSessionData("compulsory_Paper_2Subjects") || [];
    const additional_Subjects = getSessionData("additional_Subjects") || [];
    const elective_Subjects = getSessionData("electivesubj") || [];
    const optional_Paper_1_2Subjects =
      getSessionData("optional_Paper_1_2Subjects") || [];
    const cL11EndDate = getSessionData("cL11EndDate") || {};

    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteList(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setCoresubject(Array.isArray(coreSubjects) ? coreSubjects : []);
    setMatribhasa(
      Array.isArray(matri_BhasaSubjects) ? matri_BhasaSubjects : [],
    );
    setCompulsory(
      Array.isArray(compulsory_Paper_2Subjects)
        ? compulsory_Paper_2Subjects
        : [],
    );
    setAdditionalsubj(
      Array.isArray(additional_Subjects) ? additional_Subjects : [],
    );
    setOptionalsubj(
      Array.isArray(optional_Paper_1_2Subjects)
        ? optional_Paper_1_2Subjects
        : [],
    );
    setElectivefiltersubj(
      Array.isArray(elective_Subjects) ? elective_Subjects : [],
    );
    // ✅ Subject filtering based on student stream
    const stream = candidateData?.stream || "";

    const rawAadhaar = candidateData?.aadhaR_CARD || "";
    const digitsOnly = rawAadhaar.replace(/\D/g, "").slice(0, 12);
    const formattedAadhaar = digitsOnly.replace(
      /(\d{4})(\d{4})(\d{1,4})?/,
      (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" "),
    );

    const filteredCompulsory =
      compulsory_Paper_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];

    const filteredOptional =
      optional_Paper_1_2Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];

    const filteredAdditional =
      additional_Subjects?.filter(
        (subj) => subj.streams === stream || subj.streams === "ALL",
      ) || [];
    if (stream === "SCIENCE" || stream === "COMMERCE") {
      const [firstComp, secondComp] = filteredCompulsory;
      setCompulsoryonename(firstComp?.subjecT_NAME || "");
      setCompulsorytwoname(secondComp?.subjecT_NAME || "");

      setFormData((prev) => ({
        ...prev,
        compulsory_one: firstComp?.subjecT_ID || "",
        compulsory_two: secondComp?.subjecT_ID || "",
      }));

      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);

      setOptional1(candidateData.subjecT_4_CODE || "");
      setOptional2(candidateData.subjecT_5_CODE || "");
    } else if (stream === "ARTS") {
      setArtsSubjects(filteredCompulsory);
      setOptionalfiltersubj(filteredOptional);
      setAdditionalfiltersubj(filteredAdditional);
      setSelectedArtsSubjects({
        arts_optional_one: candidateData.subjecT_3_CODE || "",
        arts_optional_two: candidateData.subjecT_4_CODE || "",
        arts_optional_three: candidateData.subjecT_5_CODE || "",
      });
      setArtselective(candidateData.subjecT_2_CODE || "");
    }
    setFormData((prev) => ({
      ...prev,
      candidate_name: candidateData.candidatE_NAME || "",
      board_name: candidateData.boarD_NAME || "",
      gender: candidateData.gender || "",
      date_of_birth: candidateData.dob || "",
      fathers_name: candidateData.fatheR_NAME || "",
      mothers_name: candidateData.motheR_NAME || "",
      religion: candidateData.religion || "",
      nationality: "Indian",
      aadhaar_no: formattedAadhaar || "",
      divyang_val: candidateData.divyang || "",
      caste_val: candidateData.cast || "",
      area: candidateData?.area || "",
      state_val: candidateData?.state || "",
      district_val: candidateData?.districT_ID || "",
      block_val: candidateData?.block || "",
      address_val: candidateData?.address || "",
      pin_no: candidateData?.pincode || "",
      contact_no: candidateData?.contacT_NO || "",
      email_id: candidateData?.emaiL_ID || "",
      category_choice: candidateData.studenT_EXAM_CATEGORY_DESCRIPTION || "",
      section_val: candidateData.section || "",
      clasS_ROLL_NO: candidateData.clasS_ROLL_NO || "",
      stream: candidateData.stream || "",
      coresubject: candidateData.subjecT_1_A_CODE || "",
      matribhasa: candidateData.subjecT_1_B_CODE || "",
      additionalsubject: candidateData.subjecT_6_CODE || "",
      apaar_id: candidateData.apaaR_ID || "",
      medium_of_exam: candidateData.mediuM_OF_EXAM || "",
      // pen_no: class11otherstudent.peN_NO || "",
    }));
    setBefore2010(candidateData.beforE_2010_STATUS || "");
    setPhotoName(candidateData.studenT_PHOTOGRAPH || "");
    setSignName(candidateData.studenT_SIGNATURE || "");
    setCasteName(candidateData.castE_CERTIFICATE || "");
    setDivyangName(candidateData.divyanG_CERTIFICATE || "");
    setPhotourl(candidateData.studenT_PHOTOGRAPH_URL || "");
    setSignurl(candidateData.studenT_SIGNATURE_URL || "");
    setCasteurl(candidateData.castE_CERTIFICATE_URL || "");
    setDivyangurl(candidateData.divyanG_CERTIFICATE_URL || "");
    setOlddivyangFile(candidateData.divyanG_CERTIFICATE || "");
    setExRegularOrNot(
      candidateData.studenT_EXAM_CATEGORY_DESCRIPTION === "EX-REGULAR"
        ? true
        : false,
    );
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Formatting logic
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value
        .toUpperCase()
        .replace(/[^A-Z\s]/g, "")
        .slice(0, 35);
    }

    if (name === "aadhaar_no") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 12);
      formattedValue = digitsOnly.replace(
        /(\d{4})(\d{4})(\d{1,4})?/,
        (_, p1, p2, p3 = "") => [p1, p2, p3].filter(Boolean).join(" "),
      );
    }
    if (name === "section_val") {
      setFormData((prev) => ({
        ...prev,
        section_val: value,
        clasS_ROLL_NO: "", // reset class roll no
      }));
    }
    if (name === "category_choice") {
      setFormData((prev) => ({
        ...prev,
        category_choice: formattedValue,
        stream: "",
        section_val: "",
        clasS_ROLL_NO: "",
      }));
    }
    // if (name === "apaar_id") {
    //   formattedValue = value
    //     .replace(/\D/g, "")
    //     .slice(0, 12)
    //     .replace(/(\d{4})(?=\d)/g, "$1  ")
    //     .trim();
    // }

    if (name === "contact_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    if (name === "pin_no") {
      formattedValue = value.replace(/\D/g, "").slice(0, 6);
    }
    // if (name === "pen_no") {
    //   formattedValue = value.replace(/\D/g, "");
    // }

    if (name === "clasS_ROLL_NO") {
      formattedValue = value.replace(/\D/g, "");
    }

    if (name === "address_val") {
      formattedValue = value.replace(/[^a-zA-Z0-9 ,]/g, "");
    }

    if (name === "email_id") {
      formattedValue = value.toLowerCase().replace(/[^a-z0-9@._]/g, "");
    }
    // if (name === "pen_no") {
    //   formattedValue = value.replace(/\D/g, "");
    // }
    if (name === "apaar_id") {
      formattedValue = value.replace(/\D/g, "");
    }
    // Dependent dropdown handling
    if (name === "state_val") {
      setFormData((prev) => ({
        ...prev,
        state_val: formattedValue,
        district_val: "", // reset district
        block_val: "", // reset block
      }));
    } else if (name === "district_val") {
      setFormData((prev) => ({
        ...prev,
        district_val: formattedValue,
        block_val: "", // reset block
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }

    // Clear validation errors on input change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleArtsSubjects = () => {
    setSelectedSubjectNames((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      additionalsubject: "",
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
      optional1: "",
      optional2: "",
      artselective: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      coresubject: "",
      matribhasa: "",
      compulsory_one: "",
      compulsory_two: "",
      additionalsubject: "",
    }));
    setSelectedArtsSubjects({
      arts_optional_one: "",
      arts_optional_two: "",
      arts_optional_three: "",
    });
    setOptional1("");
    setOptional2("");
    setArtselective("");

    // Include ARTS + ALL
    const filtered = compulsory.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    setArtsSubjects(filtered);

    const filteredOptional = optionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    const filteredadditional = additionalsubj.filter(
      (subject) => subject.streams === "ARTS" || subject.streams === "ALL",
    );
    setAdditionalfiltersubj(filteredadditional);
    setOptionalfiltersubj(filteredOptional);
  };

  const handlePreview = async () => {
    setLoading(true);

    const trimmed = (val) => (val || "").trim();
    
    const newErrors = {};
    const candidateName = trimmed(formData.candidate_name);
    const fathersName = trimmed(formData.fathers_name);
    const mothersName = trimmed(formData.mothers_name);
    setTimeout(() => {
      if (!formData.gender) newErrors.gender = "Gender is required.";
      
      if (candidateName) {
        if (
          fathersName &&
          mothersName &&
          candidateName.toLowerCase() === fathersName.toLowerCase() &&
          candidateName.toLowerCase() === mothersName.toLowerCase()
        ) {
          newErrors.candidate_name =
            "Candidate name cannot be the same as Father's and Mother's name.";
          newErrors.fathers_name =
            "Father's name cannot be the same as Candidate and Mother's name.";
          newErrors.mothers_name =
            "Mother's name cannot be the same as Candidate and Father's name.";
          toast.error(
            "All names are the same! Candidate, Father's name, and Mother's name cannot be the same.",
          );
        } else {
          if (
            fathersName &&
            candidateName.toLowerCase() === fathersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Father's name.";
            newErrors.fathers_name =
              "Father's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Father's name.",
            );
          }
          if (
            mothersName &&
            candidateName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.candidate_name =
              "Candidate name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Candidate name.";
            toast.error(
              "Duplicate names! Candidate name cannot be the same as Mother's name.",
            );
          }
          if (
            fathersName &&
            mothersName &&
            fathersName.toLowerCase() === mothersName.toLowerCase()
          ) {
            newErrors.fathers_name =
              "Father's name cannot be the same as Mother's name.";
            newErrors.mothers_name =
              "Mother's name cannot be the same as Father's name.";
            toast.error(
              "Duplicate names! Father's name cannot be the same as Mother's name.",
            );
          }
        }
      }
      if (!formData.mothers_name)
        newErrors.mothers_name = "Mother Name is required.";
      if (!formData.fathers_name)
        newErrors.fathers_name = "Father Name is required.";
      

      setErrors(newErrors);
      const noErrors = Object.keys(newErrors).length === 0;
      if (!noErrors) {
        const firstErrorKey = Object.keys(newErrors)[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstErrorKey}"]`,
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsPreviewed(true);
      }
      setLoading(false);
    }, 500);
  };

  const handleButtonClick = () => {
    handleSubmit();
  };
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("intermediateAdminToken");
    const cleanAadhaar = (formData.aadhaar_no || "").replace(/\D/g, "");
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    const fd = new FormData();
    fd.append("CANDIDATE_CODE", candidateData.candidatE_ID || "");
    fd.append("GENDER", formData.gender || "");
    fd.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");

    console.log(fd);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminUpdateDataStudentGender_CL11`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: fd,
        },
      );

      const data = await response.json();

      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Gender updated Successfully",
        });

        navigate("/intermediate-gender-details-update-xi");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };
  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    // setCandidateid12(candidateid12 || "");
    // setCastecode12(formData.caste_val || "");
    // setDivyangcode12(formData.divyang_val || "");
  };
  // Document related functions
 
  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };

  return (
    <>
      <div class="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Student
                      Gender Correction for Class XI
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/intermediate-admin-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active">
                        {" "}
                        Gender Correction for Class XI
                      </li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Name of Student{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    className={`form-control form-control-sm ${
                                      errors.candidate_name ? "is-invalid" : ""
                                    }`}
                                    name="candidate_name"
                                    placeholder="Cadidate Name"
                                    value={formData.candidate_name}
                                    onChange={handleChange}
                                  />
                                  {errors.candidate_name && (
                                    <div className="text-danger mt-1 small">
                                      {errors.candidate_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <select
                                  className="form-select form-select-sm"
                                  name="gender"
                                  disabled={isPreviewed || exregularornot}
                                  onChange={handleChange}
                                  value={formData.gender?.toUpperCase()}
                                >
                                  <option value="">Select</option>
                                  <option value="MALE">MALE</option>
                                  <option value="FEMALE">FEMALE</option>
                                  <option value="TRANSGENDER">
                                    TRANSGENDER
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Date of Birth{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <DatePicker
                                  minDate={new Date(1975, 0, 1)}
                                  maxDate={
                                    candidateData.beforE_2010_STATUS === "NO"
                                      ? new Date(2012, 2, 1)
                                      : new Date()
                                  }
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd),
                                          );
                                        })()
                                      : null
                                  }
                                  onChange={handleChangeDate}
                                  dateFormat="dd-MM-yyyy"
                                  className={`form-control form-control-sm ${
                                    errors.date_of_birth ? "is-invalid" : ""
                                  }`}
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                                {errors.date_of_birth && (
                                  <div className="text-danger mt-1 small">
                                    {errors.date_of_birth}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Father’s Name{" "}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="fathers_name"
                                    disabled
                                    className={`form-control form-control-sm ${
                                      errors.fathers_name ? "is-invalid" : ""
                                    }`}
                                    value={formData.fathers_name}
                                    onChange={handleChange}
                                  />
                                </div>
                                {errors.fathers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.fathers_name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Mother’s Name{" "}
                                  {candidateData.entrY_FORM != "EX_REGULAR" && (
                                    <span class="text-danger">*</span>
                                  )}
                                </label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mothers_name"
                                    onChange={handleChange}
                                    disabled
                                    className={`form-control form-control-sm ${
                                      errors.mothers_name ? "is-invalid" : ""
                                    }`}
                                    value={formData.mothers_name}
                                  />
                                </div>
                                {errors.mothers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.mothers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    
    </>
  );
}

export default StudentGenderChangeXI;
